import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from './components/error-boundary';
import { AppProvider } from './context/app-context';
import { router } from './routes';

export function App() {
  return (
    <ErrorBoundary>
      <AppProvider>
        <RouterProvider router={router} />
      </AppProvider>
    </ErrorBoundary>
  );
}
